import {
  Button,
  Flex,
  Grid,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";

import useErrors from "hooks/useErrors";
import LabelRequired from "components/utils/LabelRequired";
import CompaniesChoose from "components/companies/CompaniesChoose";

const EquipmentTypeForm = ({ onSubmit, type = "create", initialValues }) => {
  const [equipmentTypeForm, setEquipmentTypeForm] = useState(initialValues);
  const [resetValues, setResetValues] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
  });
  const validateErrors = useErrors({
    name: "isRequired",
  });

  const onSubmitForm = () => {
    let hasErrors = false;

    Object.entries(equipmentTypeForm).forEach((itemForm) => {
      const [name, value] = itemForm;
      const check = !!checkErrors(name, value);
      if (!hasErrors) hasErrors = check;
    });

    if (
      !equipmentTypeForm.companies ||
      equipmentTypeForm.companies?.length <= 0
    ) {
      toast.error(strings.validations.companiesRequired);
      return;
    }

    if (!hasErrors)
      onSubmit({
        ...equipmentTypeForm,
        companies: equipmentTypeForm.companies.map((c) => c.id),
      });
  };

  const onChangeCompanies = (companies) => {
    setEquipmentTypeForm((prevSt) => ({
      ...prevSt,
      companies,
    }));
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setEquipmentTypeForm((prevSt) => ({
      ...prevSt,
      [name]: value,
    }));
    checkErrors(name, value);
  };

  const checkErrors = (name, value) => {
    const errorMessage = validateErrors(name, value);
    if (errorMessage)
      setErrors((prevErr) => ({ ...prevErr, [name]: errorMessage }));
    else setErrors((prevErr) => ({ ...prevErr, [name]: "" }));
    return errorMessage;
  };

  const resetFormValues = () => {
    setErrors({
      name: "",
    });
    setEquipmentTypeForm(initialValues);
    setResetValues((prev) => !prev);
  };

  useEffect(() => {
    setEquipmentTypeForm(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  return (
    <>
      <Grid rowGap="15px" columnGap="15px" padding="20px">
        <Grid gap="15px" templateColumns={{ base: "1fr" }}>
          <TextField
            name="name"
            label={<LabelRequired text={strings.fields.name.label} />}
            value={equipmentTypeForm.name}
            onChange={onChange}
            errorMessage={errors.name}
            hasError={!!errors.name}
          ></TextField>
        </Grid>
        <TextAreaField
          name="description"
          label={strings.fields.description.label}
          value={equipmentTypeForm.description}
          onChange={onChange}
        ></TextAreaField>
        <CompaniesChoose
          initCompaniesGranted={initialValues.companies || []}
          onChangeCompaniesGranted={onChangeCompanies}
          resetValues={resetValues}
        />
        <Flex justifyContent="end">
          <Button
            children={strings.fields.buttons.reset}
            onClick={resetFormValues}
          ></Button>
          <Button
            children={
              type === "create"
                ? strings.fields.buttons.create
                : strings.fields.buttons.save
            }
            onClick={onSubmitForm}
            variation="primary"
            isDisabled={Object.values(errors).some((e) => !!e)}
          ></Button>
        </Flex>
      </Grid>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      name: {
        label: "Nombre",
      },
      description: {
        label: "Descripción",
      },
      company: {
        label: "Empresa",
        placeholder: "Buscar empresa...",
      },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
      },
    },
    responses: {
      errorFetchCompanies: "Error al consultar empresas",
    },
    validations: {
      companiesRequired: "Al menos 1 empresa es requerida",
    },
  },
});

export default EquipmentTypeForm;
